<template>
    <v-container fluid>
        <v-row>
            <v-col cols="12" sm="6" md="4">
                <v-select label="*Periodo" outlined
                    v-model="dIdMatricula"
                    :items=dMatriculas item-value="IdMatricula" item-text="Periodo"
                    :loading="dIsLoading"
                ></v-select>
            </v-col>
            <v-col cols="12" sm="6" md="4">
                <v-select v-if="dIdMatricula" v-model="dIdMes" :items=dMeses item-value="idMes" item-text="Mes" label="*Mes" outlined></v-select>
            </v-col>
            <v-col cols="12" sm="6" md="4">
                <v-btn v-if="dIdMatricula && dIdMes" @click.prevent="fuSearch" color="blue-grey" dark x-large>
                    <v-icon large left>search</v-icon> Buscar
                </v-btn>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12" sm="12">
                <v-simple-table class="border">
                    <thead>
                        <tr>
                        <th class="border-right">Curso</th>
                        <th v-for="dia in dDiasUnicos" :key="dia" class="text-center border-right body-1">{{ dia }}</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(asistencias, curso) in dCursosUnicos" :key="curso">
                            <td class="border-right"><span class="overline">{{ curso }}</span></td>
                            <td v-for="dia in dDiasUnicos" :key="dia" class="text-center border-right pa-0" :class="asistencias[dia]" :title="asistencias[dia]"></td>
                        </tr>
                    </tbody>
                </v-simple-table>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import { format, parseISO } from 'date-fns';

import gql from 'graphql-tag';
import Swal from 'sweetalert2/dist/sweetalert2.js';
import 'sweetalert2/src/sweetalert2.scss';
import { fuMesNombre } from '@/helpers/index.js';

export default {
    name: 'DcbAsistenciaMatricula',
    props: ['pIdAlumno'],
    mounted(){
    	this.fuLoad(this.pIdAlumno);
    },
    data: () => ({
        dIdMatricula: null,
        dIdMes: null,
        dIsLoading: false,
        dMatriculas: [],
        dMeses: [],
        dCursosUnicos: [],
        dDiasUnicos: [],
    }),
    watch: {
        pIdAlumno(val){
            if(val)
                this.fuLoad(val);
        },
        dIdMatricula(val){
            if(val){
                this.dMeses = [];
                this.dIdMes = null;
                let vFechaInicio = new Date(this.dMatriculas.find(item => item.IdMatricula === val).FechaInicio);
                
                for (let i = 0; i < 5; i++) {
                    this.dMeses.push({ idMes: vFechaInicio.getMonth()+1 , Mes: fuMesNombre(vFechaInicio.getMonth()+1) + ' - ' + vFechaInicio.getFullYear()});
                    vFechaInicio.setMonth(vFechaInicio.getMonth() + 1)
                }
            }
        },
    },
    methods: {
        async fuLoad(vIdAlumno){
            this.dIsLoading = true;
            let vIdSeccions ="";

            this.dCursosUnicos = [];
            this.dDiasUnicos = [];
            try {
                const response = await this.$apollo.query({
                    query: gql`query load($IdAlumno: ID!){
                        matmatriculasByIdAlumno(IdAlumno:$IdAlumno){
                            IdMatricula
                            matseccion{
                                Seccion
                                FechaInicio
                                matperiodo{
                                    Anio
                                    Periodo
                                    Nivel
                                }
                            }
                        }
                    }`,
                    variables: {
                        IdAlumno: vIdAlumno,
                    },
                    fetchPolicy: 'no-cache'
                })
                let query = response.data.matmatriculasByIdAlumno.map(item =>{
                    return {
                        IdMatricula: item.IdMatricula,
                        Periodo: item.matseccion.matperiodo.Anio + '-' + item.matseccion.matperiodo.Periodo + ' ' + item.matseccion.matperiodo.Nivel + item.matseccion.Seccion,
                        FechaInicio: item.matseccion.FechaInicio
                    };
                });
                this.dMatriculas = query.sort((a, b) => b.IdMatricula - a.IdMatricula);
            } catch (error) {
                console.log(error);
                Swal.fire('¡ ERROR !', 'Problema de Conexión.', 'error');
            } finally {
                this.dIsLoading = false
            }
        },
        async fuSearch(){
            try {
                const response = await this.$apollo.query({
                    query: gql`query dcbasistenciaByIdMatriculaByMes($IdMatricula: Int!, $Mes: Int!){
                        dcbasistenciaByIdMatriculaByMes(IdMatricula:$IdMatricula, Mes:$Mes){
                            IdAsistencia
                            IdCursoCurricula
                            Curso
                            Sesion
                            Observaciones
                            FechaAvance
                        }
                    }`,
                    variables: {
                        IdMatricula: this.dIdMatricula,
                        Mes: this.dIdMes
                    },
                    fetchPolicy: 'no-cache'
                })
                let data = response.data.dcbasistenciaByIdMatriculaByMes;
                console.log(response.data.dcbasistenciaByIdMatriculaByMes);
                
                this.procesarHorario(data);
            } catch (error) {
                console.log(error);
                Swal.fire('¡ ERROR !', 'Error de conexión.', 'error');
            } finally {
            }
        },
        procesarHorario(data) {
            const dias = new Set();
            const cursos = {};

            data.forEach(item => {
                const fecha = item.FechaAvance.split(" ")[0].split("-")[2];
                dias.add(fecha);

                if (!cursos[item.Curso]) cursos[item.Curso] = {};

                cursos[item.Curso][fecha] = item.Observaciones || '-';
            });

            this.dDiasUnicos = Array.from(dias).sort();
            this.dCursosUnicos = cursos;
        }
    }
}
</script>

<style scoped>
.Presente{
    background-color: #C8E6C9 !important;
}
.Falta{
    background-color: #FFCDD2 !important;
}
.border-right {
  border-right: 1px solid #ccc;
}
.border {
  border : 1px solid #ccc;
}
</style>